
// NOTE: Server actions don't work in Vite/React SPA
// These functions should be moved to Firebase Functions or a custom API
// See MIGRATION_NOTES.md for details

import { unfurl } from 'unfurl.js';
import type { Loch } from './lib/types';
import { PlaceHolderImages } from '@/lib/placeholder-images';

export type UnfurlLinkOutput = {
  title: string;
  description: string;
  imageUrl?: string;
  domain: string;
}

const placeholderImageIds = PlaceHolderImages.map(p => p.id);

function getRandomPlaceholderId() {
    return placeholderImageIds[Math.floor(Math.random() * placeholderImageIds.length)];
}

export async function getWeatherAction(loch: Loch) {
    try {
        const response = await fetch(`https://ai-travel-itinerary-ai-228543204937.europe-west2.run.app/api/weather/${loch.id}`);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error.message || `Failed to fetch weather: ${response.statusText}`);
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        console.error(error);
        const message = error instanceof Error ? error.message : 'Failed to fetch weather data.';
        return { success: false, error: message };
    }
}


export async function getEnhancedDetailsAction(locationName: string, baseDetails: string) {
    // AI enhancement requires a backend service
    return {
        success: false,
        error: 'AI-powered location enhancement requires a backend server. This feature is currently disabled.'
    };
}

export async function unfurlLinkAction(url: string) {
    try {
        const result = await unfurl(url);
        const urlObject = new URL(url);

        const openGraph = result.open_graph || {};

        const unfurledData: UnfurlLinkOutput = {
          title: openGraph.title || result.title || 'No title found',
          description: openGraph.description || result.description || 'No description found',
          imageUrl: openGraph.images?.[0]?.url,
          domain: urlObject.hostname,
        }

        return { success: true, data: unfurledData };
    } catch (error) {
        console.error(error);
        const errorMessage = error instanceof Error ? error.message : 'Failed to unfurl link.';
        return { success: false, error: errorMessage };
    }
}
